import { H5 } from "@sellar-io/components";
import { OpeningOrderFeeListResponseType } from "@sellar-io/api-v2/types";
import { useOpeningOrderFeeList } from "../../../../hooks/api/v2/openingOrderFee/useOpeningOrderFeeList";
import { ListElement } from "../../../../components";
import { InfiniteList } from "../../../../components/infiniteLoading/InfiniteList";
import { twMerge } from "tailwind-merge";

import { useRef } from "react";
import dayjs from "dayjs";
import { formatCurrency } from "@sellar-io/common";
import { BadgeGrey } from "../../../../components/badge/Badge";

const OOFCard = ({
  OOFItem,
  setSelectedOof,
  setActive,
}: {
  OOFItem: OpeningOrderFeeListResponseType[number];
  setSelectedOof: (oof: OpeningOrderFeeListResponseType[number]) => void;
  setActive: (value: boolean) => void;
}) => {
  const { Order } = OOFItem;
  const waived = !!OOFItem.waivedAt;

  return (
    <ListElement
      onClick={() => {
        setSelectedOof(OOFItem);
        setActive(true);
      }}
    >
      <div className={twMerge("flex flex-col gap-1", waived && "line-through")}>
        <span className="text-xs">
          Invoice Date:{" "}
          {Order.createdAt ? dayjs(Order.createdAt).format("DD/MM/YYYY") : "NA"}
        </span>
        <H5>
          {Order.Retailer.Business.name} &ndash; {formatCurrency(OOFItem.fee)}
        </H5>
        <span className="text-sm">Order #{OOFItem.Order.id}</span>
        {waived && (
          <div className="mt-2">
            <BadgeGrey>Waved</BadgeGrey>
          </div>
        )}
      </div>
    </ListElement>
  );
};

export const OOFCardList = ({
  setSelectedOof,
  setActive,
  search,
}: {
  setSelectedOof: (
    selectedOof: OpeningOrderFeeListResponseType[number],
  ) => void;
  setActive: (value: boolean) => void;
  search: string;
}) => {
  const oofQuery = useOpeningOrderFeeList({
    limit: 10,
    search,
  });

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  return (
    <div
      className={twMerge(
        "[scrollbar-width:none] overflow-auto border-zinc-300 [::-webkit-scrollbar]:hidden",
      )}
      ref={scrollContainerRef}
    >
      <InfiniteList query={oofQuery}>
        {oofQuery.data?.pages.map((page) =>
          page.map((OOFItem) => (
            <OOFCard
              OOFItem={OOFItem}
              key={OOFItem.id}
              setSelectedOof={setSelectedOof}
              setActive={setActive}
            />
          )),
        )}
      </InfiniteList>
    </div>
  );
};
